import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  PrintReceiptMutationInput,
  ReceiptMutationVoid,
  ReceiptMutationInput,
  ReceiptMutationUpdate,
  ReceiptUpdateStatusInput,
} from './model';

export function useCreateReceipt(
  options?: UseMutationOptions<ApiResult<any>, ApiError, ReceiptMutationInput>,
): UseMutationResult<ApiResult<any>, ApiError, ReceiptMutationInput> {
  return useMutation<ApiResult<any>, ApiError, ReceiptMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'receipts',
        method: 'POST',
        body,
      });
    },
    options,
  );
}

export function useUpdateReceipt(
  options?: UseMutationOptions<ApiResult<any>, ApiError, ReceiptMutationUpdate>,
): UseMutationResult<ApiResult<any>, ApiError, ReceiptMutationUpdate> {
  return useMutation<ApiResult<any>, ApiError, ReceiptMutationUpdate>(
    async function (body) {
      return await MutationFetchFunction({
        url: `receipts/${body.id}`,
        method: 'PUT',
        body: body.body,
      });
    },
    options,
  );
}

export function useVoidReceipt(
  options?: UseMutationOptions<ApiResult<any>, ApiError, ReceiptMutationVoid>,
): UseMutationResult<ApiResult<any>, ApiError, ReceiptMutationVoid> {
  return useMutation<ApiResult<any>, ApiError, ReceiptMutationVoid>(
    async function (body) {
      return await MutationFetchFunction({
        url: `receipts/${body.id}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function usePrintReceipt(
  options?: UseMutationOptions<any, ApiError, PrintReceiptMutationInput>,
): UseMutationResult<any, ApiError, PrintReceiptMutationInput> {
  return useMutation<any, ApiError, PrintReceiptMutationInput>(async function (
    body,
  ) {
    return await MutationFetchFunction({
      url: `receipts/${body.id}/export`,
      method: 'POST',
    });
  },
  options);
}

export function useUpdateReceiptStatus(
  options?: UseMutationOptions<any, ApiError, ReceiptUpdateStatusInput>,
): UseMutationResult<any, ApiError, ReceiptUpdateStatusInput> {
  return useMutation<any, ApiError, ReceiptUpdateStatusInput>(async function (
    body,
  ) {
    return await MutationFetchFunction({
      url: `receipts/${body.id}/update-receipt-status`,
      body: body.body,
      method: 'PUT',
    });
  },
  options);
}
